import CicleCheckIcon from "components/icons/CicleCheckIcon";
import CicleExclamationIcon from "components/icons/CicleExclamationIcon";

const ValidationIcon = ({ available }) => {
    return (
        <div
            className={`mx-2 mt-3 shrink-0 self-center ${
                available ? "text-green-500" : "text-red-500"
            }`}
        >
            {available ? <CicleCheckIcon /> : <CicleExclamationIcon />}
        </div>
    );
};

export default ValidationIcon;
